import * as React from 'react';
import Box from '@mui/material/Box';
import { Checkbox, Divider } from 'antd';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import type { CheckboxValueType } from 'antd/es/checkbox/Group';
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs';
import Wrapper from '../components/Wrapper/Wrapper';
import classes from './FilterDescriptors.module.css';
import { Helmet } from 'react-helmet';
import rrzj_db from "../db.json";
import VideoTextContainer from '../components/VideoTextContainer/VideoTextContainer';
import { getUrlArrayFromChapter } from '../utils/utils';
import { useSearchParams } from 'react-router-dom';

const CheckboxGroup = Checkbox.Group;

const rrzjUrovenOptions = ['Pre A1', 'A1', 'A2', 'A2+', 'B1', 'B2', 'B2+', 'C1', 'C2'];
const rrzjCinnostOptions = ['RECEPCE', 'PRODUKCE', 'INTERAKCE', 'MEDIACE'];
const rrzjStupniceOptions = ['GLOBÁLNÍ', 'VŠEOBECNÁ', 'MODELOVÁ', 'STRATEGIE'];
const rrzjKompetenceOptions = ['JAZYKOVÁ', 'PRAGMALINGVISTICKÁ', 'SOCIOLINGVISTICKÁ'];

const FilterDescriptors = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [rrzjUrovenList, setRrzjUrovenList] = React.useState<CheckboxValueType[]>(searchParams.getAll('rrzj-uroven'));
  const [rrzjCinnostList, setRrzjCinnostList] = React.useState<CheckboxValueType[]>(searchParams.getAll('rrzj-cinnost'));
  const [rrzjStupniceList, setRrzjStupniceList] = React.useState<CheckboxValueType[]>(searchParams.getAll('rrzj-stupnice'));
  const [rrzjKompetenceList, setRrzjKompetenceList] = React.useState<CheckboxValueType[]>(searchParams.getAll('rrzj-kompetence'));

  const [checkAll, setCheckAll] = React.useState(false);
  const [checkAll1, setCheckAll1] = React.useState(false);
  const [checkAll2, setCheckAll2] = React.useState(false);
  const [checkAll3, setCheckAll3] = React.useState(false);

  const [displayedContent, setDisplayedContent] = React.useState<TableInterface[]>([])

  let filterRRZJ = { uroven: [], cinnost: [], stupnice: [], kompetence: [] };

  const onChange = (list: CheckboxValueType[]) => {
    setRrzjUrovenList(list);
  };

  const onChange1 = (list: CheckboxValueType[]) => {
    setRrzjCinnostList(list);
  };

  const onChange2 = (list: CheckboxValueType[]) => {
    setRrzjStupniceList(list);
  };

  const onChange3 = (list: CheckboxValueType[]) => {
    setRrzjKompetenceList(list);
  };

  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    setRrzjUrovenList(e.target.checked ? rrzjUrovenOptions : []);
    setCheckAll(e.target.checked);
  };
  const onCheckAllChange1 = (e: CheckboxChangeEvent) => {
    setRrzjCinnostList(e.target.checked ? rrzjCinnostOptions : []);
    setCheckAll1(e.target.checked);
  };
  const onCheckAllChange2 = (e: CheckboxChangeEvent) => {
    setRrzjStupniceList(e.target.checked ? rrzjStupniceOptions : []);
    setCheckAll2(e.target.checked);
  };
  const onCheckAllChange3 = (e: CheckboxChangeEvent) => {
    setRrzjKompetenceList(e.target.checked ? rrzjKompetenceOptions : []);
    setCheckAll3(e.target.checked);
  };

  const [url, setUrl] = React.useState("");
  const [playing, setPlaying] = React.useState(false);
  const [urlIndex, setUrlIndex] = React.useState(0);
  const [urlArray, setUrlArray] = React.useState<Array<string>>([]);

  /*  on submit section */
  /* this should be cached */

  const allTabesFromChapter = (chapter: any) => {
    return chapter.pars
      .filter((c: any) => {
        return c.type === "table";
      })
      .concat(
        chapter.children.reduce((result: any, current: any) => {
          return result.concat(allTabesFromChapter(current));
        }, [])
      );
  };

  const arrayOfRRZJTables = (database: any) => {
    return database.map((chapter: any) => {
      return allTabesFromChapter(chapter);
    }).flat();
  };

  interface DeskriptoryInterface {
    cinnost: string[];
    kompetence: string[];
    uroven: string[];
    stupnice: string[];
  }

  interface TableInterface {
    footnotes: {
      content: string;
      url: string;
    }[];
    headline: string;
    rows: {
      content: {
        content: string;
        url: string;
      };
      level: {
        name: string;
        tags: string[];
        url: string;
      }
    }[];
  }

  const onSubmitDeskriptory = ({ cinnost, kompetence, uroven, stupnice }: DeskriptoryInterface) => {
    const tables = arrayOfRRZJTables(rrzj_db) as TableInterface[];

    const res = tables
      .map((t) => {
        const filteredRows = t.rows.filter((row) => {
          return row.level.tags.every(
            (tag) =>
              cinnost.includes(tag) ||
              kompetence.includes(tag) ||
              uroven.includes(tag) ||
              stupnice.includes(tag) ||
              (cinnost.length === 0 && rrzjCinnostOptions.includes(tag)) ||
              (kompetence.length === 0 &&
                rrzjKompetenceOptions.includes(tag)) ||
              (uroven.length === 0 && rrzjUrovenOptions.includes(tag)) ||
              (stupnice.length === 0 && rrzjStupniceOptions.includes(tag))
          );
        });

        return { ...t, rows: filteredRows };
      })
      .filter((t) => t.rows.length !== 0);

    setDisplayedContent(res);
    setUrlArray(getUrlArrayFromChapter([{
      headline: "",
      headline_url: "",
      video_code: "",
      number: "",
      slug: "",
      references: [],
      pars: res,
      children: []
    }]).slice(1))

    setSearchParams({
      "rrzj-uroven": rrzjUrovenList as string[],
      "rrzj-cinnost": rrzjCinnostList as string[],
      "rrzj-stupnice": rrzjStupniceList as string[],
      "rrzj-kompetence": rrzjKompetenceList as string[],
    })
  };

  const onParagraphClick = (url: string) => {
    if (url.length === 0 || url.slice(0, 7) === "NOMATCH") {
      return;
    }

    setUrl(url || ""); /* Set a placeholder instead */
    setPlaying(true);

    /* update URL index when user clicks on a paragraph */
    const foundIndex = urlArray.findIndex((i: string) => i === url);

    if (foundIndex === -1) {
      setUrlIndex(0);
    } else {
      setUrlIndex(foundIndex);
    }
  };

  return (
    <Wrapper background="rgb(240, 240, 240)">
      <Helmet>
        <title>Vyhledávání v referenčním rámci</title>
      </Helmet>
      <Breadcrumbs />
      <h2 className={classes.headingTop}>Vyhledávání v referenčním rámci</h2>
      <div>
        <div style={{ display: "flex" }}>
          <div className={classes.checkboxWrapper}>
            <div className={classes.checkboxContainerRRZJ}>
              <div className={classes.checkboxHeader}>Podle úrovně</div>
              <Box sx={{ width: "100%" }}>
                <CheckboxGroup
                  style={{ display: "flex", flexDirection: "column" }}
                  options={rrzjUrovenOptions}
                  value={rrzjUrovenList}
                  onChange={onChange}
                />
              </Box>
              <Divider />
              <Checkbox onChange={onCheckAllChange} checked={checkAll}>
                Vybrat vše
              </Checkbox>
            </div>
            <div className={classes.checkboxContainerRRZJ}>
              <div className={classes.checkboxHeader}>
                Podle komunikační činnosti
              </div>
              <Box sx={{ width: "100%" }}>
                <CheckboxGroup
                  style={{ display: "flex", flexDirection: "column" }}
                  options={rrzjCinnostOptions}
                  value={rrzjCinnostList}
                  onChange={onChange1}
                />
                <Divider />
                <Checkbox onChange={onCheckAllChange1} checked={checkAll1}>
                  Vybrat vše
                </Checkbox>
              </Box>
            </div>
            <div className={classes.checkboxContainerRRZJ}>
              <div className={classes.checkboxHeader}>Typ stupnice</div>
              <Box sx={{ width: "100%" }}>
                <CheckboxGroup
                  style={{ display: "flex", flexDirection: "column" }}
                  options={rrzjStupniceOptions}
                  value={rrzjStupniceList}
                  onChange={onChange2}
                />
                <Divider />
                <Checkbox onChange={onCheckAllChange2} checked={checkAll2}>
                  Vybrat vše
                </Checkbox>
              </Box>
            </div>
          </div>
        </div>
        <div className={classes.buttonWrapper}>
          <button
            className={classes.button}
            onClick={() => {
              filterRRZJ.uroven = rrzjUrovenList as never;
              filterRRZJ.cinnost = rrzjCinnostList as never;
              filterRRZJ.stupnice = rrzjStupniceList as never;
              filterRRZJ.kompetence = rrzjKompetenceList as never;
              onSubmitDeskriptory(filterRRZJ);
            }}
          >
            Zobrazit výsledky
          </button>
        </div>
      </div>

      {displayedContent.length !== 0 && (
        <div style={{ marginTop: "2rem" }}>
          <VideoTextContainer
            chapterContent={[
              {
                headline: "",
                headline_url: "",
                video_code: "",
                number: "",
                slug: "",
                references: [],
                pars: displayedContent,
                children: []
              },
            ]}
            url={url}
            onParagraphClick={onParagraphClick}
            noVideo={false}
            urlArray={urlArray}
            urlIndex={urlIndex}
            setUrlIndex={setUrlIndex}
            playing={playing}
            setPlaying={setPlaying}
            setUrl={setUrl}
            foldableTables
          />
        </div>
      )}
    </Wrapper>
  );
}

export default FilterDescriptors;
